import React, { Component } from "react";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import PromotionDropdowns from './PromotionDropdowns';
import FeeDueValidationModal from './FeeDueValidationModal';
import PromotionSummaryModal from './PromotionSummaryModal';
import LoadingComponent from '../../loadingComponent';

// import {  } from "./components/svgIcons";


const PROMOTION_CATEGORIES = [
    { label: "Financial Promotion Only", value: "financial" },
    { label: "Full Promotion (Financial + Academic)", value: "full" }
];

class StudentPromotionModal extends Component {
    state = {
        academicYear: null,
        academicYearOptions: [],
        promotionCategory: null,
        dropdownsData: {},
        loadingYears: false,
        submitting: false,
        showFeeDueModal: false,
        showSummaryModal: false,
        studentsWithFeeDues: [],
        eligibleStudents: []
    };

    componentDidMount() {
        this.loadAcademicYears();
    }

    loadAcademicYears = () => {
        this.setState({ loadingYears: true });
        const userAcademicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/promotions/academic-years?currentAcademicYear=${userAcademicYear}`;
        new Service().get(url, true)
            .then((response) => {
                if (response.status && response.res?.data) {
                    this.setState({
                        academicYearOptions: response.res.data,
                        loadingYears: false
                    });
                } else {
                    this.setState({ loadingYears: false });
                }
            })
            .catch(() => this.setState({ loadingYears: false }));
    };

    handleDropdownsChange = (dropdownsData) => {
        this.setState(
            {
                dropdownsData: dropdownsData
            },
        );
    };

    handleSubmit = () => {
        this.setState({ submitting: true });

        // Get all selected students
        const allSelectedStudents = this.props.selectedStudentsData ?
            Array.from(this.props.selectedStudentsData.values()) : [];

        // Get selected students with fee dues (only positive dues are considered as having dues)
        const studentsWithFeeDues = allSelectedStudents.filter(student =>
            student?.feeStatus?.totalDues > 0
        );

        // All selected students are now eligible for promotion regardless of fee dues
        const eligibleStudents = allSelectedStudents;

        // Store all students as eligible in state
        this.setState({
            eligibleStudents,
            studentsWithFeeDues
        });

        if (studentsWithFeeDues.length > 0) {
            // Show fee due modal for information
            this.setState({
                submitting: false,
                showFeeDueModal: true
            });
        } else {
            // Skip fee due modal and go directly to summary modal
            this.setState({
                submitting: false,
                showSummaryModal: true
            });
        }
    };

    proceedWithPromotion = () => {
        // TODO: Implement next step or actual promotion API call
        setTimeout(() => {
            this.setState({ submitting: false });
            this.props.onClose();
        }, 1200);
    };

    onAcademicYearChange = (selectedValue) => {
        this.setState({
            academicYear: selectedValue,
            dropdownsData: {} // Reset dropdown selections
        });
    };

    proceedToSummary = () => {
        this.setState({
            showFeeDueModal: false,
            showSummaryModal: true
        });
    };

    handleFinalRequest = () => {
        this.setState({ isLoading: true });

        const payload = this.preparePromotionPayload();
        const url = `${baseUrlAdmin}/promotions/create-approval-request`;
        new Service().post(url, payload, true)
            .then((response) => {
                if (response.status && response.res?.status) {
                    this.toast?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Promotion request submitted successfully',
                        life: 3000
                    });

                    this.setState({
                        isLoading: false,
                        showSummaryModal: false
                    });
                    this.props.onClose();
                } else {
                    this.setState({ isLoading: false });
                    this.toast?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response.errMessage || 'Failed to submit promotion request',
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                console.error('Error submitting promotion request:', error);
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to submit promotion request',
                    life: 3000
                });
            });
    };

    preparePromotionPayload = () => {
        const { eligibleStudents, academicYear, promotionCategory } = this.state;
        const targetYearData = this.getTargetYearData();
        const currentYearData = this.props.currentYearData;

        const studentsData = eligibleStudents.map(student => ({
            userId: student.user_id,
            studentName: `${student.user_info?.firstName || ''} ${student.user_info?.lastName || ''}`.trim(),
            enrollmentNo: student.user_info?.enrollmentId
        }));

        return {
            requestMetadata: {
                currentAcademicYear: currentYearData?.academicYear,
                targetAcademicYear: academicYear,
                promotionCategory: promotionCategory,
                status: "pending"
            },
            currentYearDetails: currentYearData,
            targetYearDetails: {
                academicYear: academicYear,
                branchId: currentYearData?.branchId,
                branchName: targetYearData.branchName,
                boardId: this.state.dropdownsData.boardId,
                boardName: targetYearData.boardName,
                classId: this.state.dropdownsData.classId,
                className: targetYearData.className,
                sectionId: this.state.dropdownsData.sectionId,
                sectionName: targetYearData.sectionName
            },
            requestedStudentsCount: eligibleStudents.length,
            students: studentsData
        };
    };

    getSelectedAcademicYearLabel = () => {
        const selectedYear = this.state.academicYearOptions.find(
            option => option.value === this.state.academicYear
        );
        return selectedYear?.label || '';
    };

    getPromotionCategoryLabel = () => {
        const selectedCategory = PROMOTION_CATEGORIES.find(
            option => option.value === this.state.promotionCategory
        );
        return selectedCategory?.label || '';
    };

    // Improved method to get target year data
    getTargetYearData = () => {
        const { dropdownsData, academicYearOptions } = this.state;
        const selectedAcademicYear = academicYearOptions.find(option => option.value === this.state.academicYear);

        return {
            branchName: this.props.currentYearData?.branchName, // Same branch as current
            boardName: dropdownsData.selectedBoard?.boardName || dropdownsData.selectedBoard?.label,
            className: dropdownsData.selectedClass?.className || dropdownsData.selectedClass?.label,
            sectionName: dropdownsData.selectedSection?.sectionName || dropdownsData.selectedSection?.label,
            academicYear: selectedAcademicYear?.label
        };
    };

    render() {
        const { onClose } = this.props;
        const {
            academicYear,
            academicYearOptions,
            promotionCategory,
            dropdownsData,
            loadingYears,
            submitting,
            showFeeDueModal,
            showSummaryModal,
            studentsWithFeeDues,
            eligibleStudents
        } = this.state;

        const totalSelectedStudents = this.props.selectedStudentsData ?
            this.props.selectedStudentsData.size : 0;

        return (
            <>
                <Dialog
                    visible={!showFeeDueModal && !showSummaryModal}
                    modal
                    style={{ width: '90vw', maxWidth: '1000px', borderRadius: '16px', padding: 0 }}
                    className="promotion-modal"
                    onHide={onClose}
                    header={null}
                    closable={false}
                >
                    <div style={{ position: 'relative', minHeight: 'auto' }}>
                        {/* Close Button */}
                        <button
                            onClick={onClose}
                            style={{
                                position: 'absolute',
                                top: 18,
                                right: 18,
                                background: 'transparent',
                                border: 'none',
                                fontSize: 22,
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                            aria-label="Close"
                        >
                            &#10005;
                        </button>

                        <div className="flex flex-column align-items-center py-3 px-4">
                            {/* Icon Above Title */}
                            <div className="flex justify-content-center align-items-center" style={{ marginBottom: 12 }}>
                                <span style={{
                                    background: "#D1FADF",
                                    borderRadius: "50%",
                                    padding: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "64px",
                                    height: "64px"
                                }}>
                                    <span style={{ fontSize: 32 }}>
                                        <i className="fa fa-graduation-cap" />
                                    </span>
                                </span>
                            </div>

                            <h3 className="font-bold text-center mb-3" style={{ fontSize: 22 }}>Request Student Promotion</h3>

                            {/* Top Row - Academic Session and Promotion Category */}
                            <div className="grid w-full mb-3">
                                <div className="col-6 px-2">
                                    <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                                        Target Academic Session<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Dropdown
                                        value={academicYear}
                                        options={academicYearOptions}
                                        onChange={(e) => this.onAcademicYearChange(e.value)}
                                        placeholder="Select Academic Session"
                                        className="w-full"
                                        optionLabel="label"
                                        optionValue="value"
                                        loading={loadingYears}
                                    />
                                    <small className="text-muted">Single Select</small>
                                </div>
                                <div className="col-6 px-2">
                                    <label className="font-semibold mb-1 block" style={{ fontSize: 15 }}>
                                        Promotion Category<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Dropdown
                                        value={promotionCategory}
                                        options={PROMOTION_CATEGORIES}
                                        onChange={(e) => this.setState({ promotionCategory: e.value })}
                                        placeholder="Select Category"
                                        className="w-full"
                                    />
                                    <small className="text-muted">Single Select</small>
                                </div>
                            </div>

                            {/* Custom Promotion Dropdowns */}
                            <div className="px-3 w-full mb-3">
                                <PromotionDropdowns
                                    ref={(ref) => this.promotionDropdownsRef = ref}
                                    academicYear={academicYear}
                                    setValues={this.handleDropdownsChange}
                                    currentBranchId={this.props.currentBranchId} // Pass current branch ID
                                />
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-content-center gap-3 mt-2">
                                <Button
                                    label="Request"
                                    className="p-button"
                                    style={{
                                        background: "#2E90FA",
                                        borderRadius: "8px",
                                        padding: "10px 32px",
                                        fontWeight: 600,
                                        fontSize: 16,
                                        color: "#fff",
                                        border: "none"
                                    }}
                                    disabled={submitting || !academicYear || !promotionCategory || !dropdownsData.boardId || !dropdownsData.classId || !dropdownsData.sectionId}
                                    onClick={this.handleSubmit}
                                />
                                <Button
                                    label="Cancel"
                                    className="p-button-outlined"
                                    style={{
                                        borderRadius: "8px",
                                        padding: "10px 32px",
                                        fontWeight: 600,
                                        fontSize: 16,
                                        border: "none",
                                        background: "#F2F4F7",
                                        color: "#344054"
                                    }}
                                    onClick={onClose}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>

                <FeeDueValidationModal
                    visible={showFeeDueModal}
                    onHide={() => this.setState({ showFeeDueModal: false })}
                    onNext={this.proceedToSummary}
                    studentsWithFeeDues={studentsWithFeeDues}
                    eligibleStudents={eligibleStudents}
                />

                <PromotionSummaryModal
                    visible={showSummaryModal}
                    onHide={() => this.setState({ showSummaryModal: false })}
                    onRequest={this.handleFinalRequest}
                    onCancel={() => this.setState({ showSummaryModal: false })}
                    targetAcademicSession={this.getSelectedAcademicYearLabel()}
                    promotionCategory={this.getPromotionCategoryLabel()}
                    eligibleStudents={eligibleStudents}
                    totalSelectedStudents={totalSelectedStudents}
                    currentYearData={this.props.currentYearData} // Pass from props
                    targetYearData={this.getTargetYearData()} // Get from selections
                />
                {this.state.isLoading && <LoadingComponent />}
            </>
        );
    }
}

export default StudentPromotionModal;